import React from 'react'
import { Form } from 'semantic-ui-react'

/**
 * @param {object} props
 * @param {function} props.onChange
 * @param {string=} props.className
 * @param {boolean} props.isRemovePlaceholder
 */
export default function PlaceholderRemoverForm({ onChange, className, isRemovePlaceholder }) {
  function handleChange(_, { checked }) {
    onChange(checked)
  }

  return (
    <Form className={className}>
      <label className="bold">Data sent through rating URLs</label>
      <Form.Group inline className="mt2">
        <Form.Checkbox
          checked={isRemovePlaceholder}
          onChange={handleChange}
          name="placeholder-remover"
          label="Remove placeholders from rating URLs"
        />
      </Form.Group>
    </Form>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/PlaceholderRemoverForm/index.js